export const MAIN_ROUTE: string = '/';
export const ADMIN_ROUTE: string = '/admin';
export const PORTFOLIO_ROUTE: string = '/portfolio';
export const SKILLS_ROUTE: string = '/skills';
export const ABOUT_ROUTE: string = '/about';
export const CONTACTS_ROUTE: string = '/contacts';
export const POLICY_ROUTE: string = '/policy';